import React from 'react';

import {
  SidepanelChange,
  SidepanelInternalState,
  SidepanelRegisterTabState,
} from './useFlowchartSidepanelManager';

export interface FlowchartSidepanelManagerContextValue {
  registerTab: (params: SidepanelRegisterTabState) => void;
  unregisterTab: (tab: string) => void;
  setIsTabDirty: (tab: string, isDirty: boolean) => void;
  changeSidepanel: (sidepanelChange: SidepanelChange) => Promise<boolean>;
  changeTab: (newTab: string, activeTab: string) => Promise<boolean>;
  forceClose: () => void;
  getEffectiveState: () => SidepanelInternalState;
}

export const FlowchartSidepanelManagerContext = React.createContext<FlowchartSidepanelManagerContextValue>({
  registerTab: () => {},
  unregisterTab: () => {},
  setIsTabDirty: () => {},
  changeSidepanel: () => Promise.resolve(true),
  changeTab: () => Promise.resolve(true),
  forceClose: () => {},
  getEffectiveState: () => ({node: null, fieldId: null, openSidepanelType: null}),
});
